// How a ticket's type reads wherever a person sees it: "Appliance — Fridge"
// when a sub-type was chosen, otherwise just "Appliance". Mirrors
// Server/utils/requestSubTypes.js → requestTypeLabel.
export const requestTypeLabel = (ticket) => {
  const type = String(ticket?.requestType ?? "").trim();
  const sub = String(ticket?.requestSubType ?? "").trim();
  if (!type) return sub;
  return sub ? `${type} — ${sub}` : type;
};

// Boxicons class for a request type's list icon. Request types are free text
// per company, so match on keywords and fall back to a wrench.
const TYPE_ICONS = [
  [/plumb|leak|water|drain|toilet|sink|faucet/i, "bx bx-water"],
  [/electric|power|outlet|breaker/i, "bx bx-bolt-circle"],
  [/light|bulb|lamp/i, "bx bx-bulb"],
  [/heat|furnace|boiler|thermo/i, "bx bxs-thermometer"],
  [/hvac|air|a\/c|vent|cool/i, "bx bx-wind"],
  [/applian|fridge|stove|oven|washer|dryer|dishwasher/i, "bx bx-cube"],
  [/lock|key/i, "bx bx-key"],
  [/door|window/i, "bx bx-door-open"],
  [/pest|bug|insect|mouse|rodent/i, "bx bx-bug"],
  [/paint|wall/i, "bx bx-paint"],
  [/clean/i, "bx bx-spray-can"],
];
export const requestTypeIcon = (requestType) => {
  const type = String(requestType ?? "");
  const hit = TYPE_ICONS.find(([re]) => re.test(type));
  return hit ? hit[1] : "bx bx-wrench";
};

// The sub-types configured for a request type, by name, from the list that
// POST /requesttype/getrequest returns. Empty when the type has none — and
// then no sub-type field should be shown at all.
export const subTypesFor = (requestTypeList, requestTypeName) => {
  const match = (requestTypeList || []).find(
    (t) => String(t?.request_type ?? "") === String(requestTypeName ?? "")
  );
  return Array.isArray(match?.sub_types)
    ? match.sub_types.map((s) => String(s ?? "").trim()).filter(Boolean)
    : [];
};
